import React, { Suspense, lazy, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as Loading from "@repoflow/components/loading";

import { Filter, DEFAULT_RANGE, buildFilter, rangeLabel } from "components/statistics/filter";

// recharts and its d3 tree are ~100KB gzipped. Lazily loaded so /point — the
// section this app is actually worked in — never pays for them, the same way
// bucketws' and auth's dashboards do it. This is the first React.lazy in this
// app; `Filter` above is imported eagerly because it must render before the chunk
// lands, and it is what the e2e waits on.
const OrganizationCharts = lazy(() => import("../charts"));

export const Sidebar = () => null;

export const Indice = () => null;

// Everything about this ORGANIZATION that is a number, on one screen: what it did
// over the selected window. This is auth's dashboard exactly — the same filter
// row over the same charts. bucketws' keeps one panel above its filter, and that
// is not a divergence: its panel is the organization's OWN size limit, one row
// scoped to the same thing the screen is scoped to. datum declares no limit
// against its statistics point, so there is no equivalent row to draw here.
//
// EVERYTHING HERE IS A WINDOW, and four of the five measures in it are deltas:
// +1 as a point, limit, limit value or key appears and -1 as it goes. So nothing
// on this screen is a holding — "how many points does this organization have" is
// the sum over all of history, and datum clamps a capture window to 31 days. The
// fifth, sessions, only ever adds, so its total is complete and is the one figure
// here that means what it looks like.
//
// The usage cards used to sit above the filter and were the one absolute on the
// screen. They were REMOVED on 2026-08-11 and moved onto the point they describe,
// at /point/:pointId — one card per point is not a figure about the organization,
// which is what this screen is scoped to. What it costs is that this screen now
// has no absolute anywhere on it, which is the gap already recorded as P104
// (bucketws) and P107 (auth) and is now P121 here. See docs/datum-statistics.md.
export const Content = () => {
  const [applied, setApplied] = useState(() => ({
    filter: buildFilter({ range: DEFAULT_RANGE }),
    range: DEFAULT_RANGE,
  }));

  return (
    <Container>
      <div className="mt-4"></div>

      {/* One filter row above everything it scopes. Both aggregates below
          re-render against this slice and neither has a filter of its own.

          It produces a range and an event type, and no dimension at all: orgId
          is forced by the server and rejected if sent, and pointId is grouped
          by rather than filtered on. */}
      <Row>
        <Col>
          <Filter onApply={setApplied} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Suspense fallback={<Loading.Content />}>
            <OrganizationCharts
              filter={applied.filter}
              range={applied.range}
              rangeLabel={rangeLabel(applied.range)}
            />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};
